import { envConfig } from "@env/env-config";

export const CountryRestServiceConfig: Array<qpmn.common.rest.IServiceConfig> = [
    {
        service: "countryRestService",
        funcName: "getCountryList",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/api/countries/sanction",
            paramDefaults: {
                page: "@page",
                limit: "@limit",
            }
        }
    },
    {
        service: "countryRestService",
        funcName: "getZoneByCountryId",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/api/countries/:countryId/zones",
            paramDefaults: { countryId: "@countryId" }
        }
    }
]